import React from 'react';
import { SimpleSection } from '../simpleSection';
import { Title } from '../title';

interface ErroProps {
    isMobile?: boolean;
}

export const Erro: React.FC<ErroProps> = ({ isMobile }) => {
    return (
        <div>
            <div className="container">
                <div className="row d-flex resultado">
                    <div className="col-xs-24 p-3">
                        <SimpleSection>
                            <span
                                style={{
                                    display: 'flex',
                                    padding: '10px',
                                    background: 'red',
                                    width: '33px',
                                    height: '33px',
                                    borderRadius: '100%',
                                    color: '#FFFFFF',
                                    fontSize: '20px',
                                    textAlign: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                className="fas fa-times"
                            ></span>
                            <Title text={'Ooops...'} />
                            <p>Um problema ocorreu e não foi possível finalizar seu agendamento.</p>
                            <p>Por favor, tente novamente mais tarde</p>
                        </SimpleSection>
                    </div>
                </div>
            </div>
        </div>
    );
};
